import { useState, useEffect } from 'react';

import { MOBILE_BREAKPOINT } from './utils/device-size.constants';

/** Retorna `isMobile` baseado no breakpoint de 991px, usando matchMedia. */
const useDeviceSize = (): { isMobile: boolean } => {
  const [isMobile, setIsMobile] = useState(
    () => globalThis.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches,
  );

  useEffect(() => {
    const mq = globalThis.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return { isMobile };
};

export { useDeviceSize };
